module.exports = __webpack_public_path__ + "static/media/packiot-dark.3c9deecb.svg";